/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($contentDetailId: ID) {
    AdminDeleteContent(contentDetailId: $contentDetailId) {
      status
      message
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
